module.exports = __webpack_public_path__ + "static/media/Visa_Logo.6dd1e8b3.png";